export { default as ColorSwatchInput } from './ColorSwatchInput'



// WEBPACK FOOTER //
// ./src/components/colorSwatchInput/index.js